export type SortDirection = "asc" | "desc";

export type SortRule = {
  field: string;
  direction: SortDirection;
};

export const normalizeSortRules = (
  rules: any,
  allowedKeys?: Iterable<string>,
): SortRule[] => {
  if (!Array.isArray(rules)) return [];

  const allowed = allowedKeys
    ? new Set(Array.from(allowedKeys).map((key) => String(key)))
    : null;
  const seen = new Set<string>();

  return rules.reduce((acc: SortRule[], rule: any) => {
    const field = String(rule?.field || rule?.key || "").trim();
    if (!field || seen.has(field) || (allowed && !allowed.has(field))) {
      return acc;
    }

    seen.add(field);
    acc.push({
      field,
      direction: String(rule?.direction || "").toLowerCase() === "desc" ? "desc" : "asc",
    });
    return acc;
  }, []);
};

export const sortRulesToQuery = (
  rules: any,
  allowedKeys?: Iterable<string>,
): string | undefined => {
  const normalized = normalizeSortRules(rules, allowedKeys);
  return normalized.length ? JSON.stringify(normalized) : undefined;
};